import React from "react"
import { Card, Table } from "react-bootstrap"
import PropTypes from "prop-types"

const DynamicSkeleton = ({ rows, columnConfig, infiniteScroll }) => {
  const columns = Object.keys(columnConfig)

  return (
    <>
      {!infiniteScroll ? (
        <Card className="overflow-y-auto">
          <Card.Body>
            <Table className="rounded mb-0 table-striped" responsive="md">
              <thead>
                <tr>
                  {columns.map((column, index) => (
                    <th
                      key={index}
                      className={
                        columnConfig[column].center ? "text-center" : ""
                      }
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={
                          columnConfig[column].center ? "text-center" : ""
                        }
                      >
                        {columnConfig[column].content}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ) : (
        <Table className="rounded mb-0 table-striped" responsive="md">
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    className={columnConfig[column].center ? "text-center" : ""}
                  >
                    {columnConfig[column].content}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  )
}

DynamicSkeleton.propTypes = {
  rows: PropTypes.number.isRequired,
  columnConfig: PropTypes.objectOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      center: PropTypes.bool,
    })
  ).isRequired,
  infiniteScroll: PropTypes.bool,
}

export default DynamicSkeleton
